/*
 * LienzoMoments — boton flotante de WhatsApp
 * ---------------------------------------------------------------------------
 * Lo unico que hace este script es evitar que el boton tape la sticky bar de
 * anadir al carrito.
 *
 * En movil la sticky bar es una banda a ancho completo pegada a `bottom: 0`,
 * y el boton flotante vive justo encima de su esquina derecha. En escritorio
 * la misma barra mide 600px centrados, asi que a partir de cierto ancho de
 * ventana ya no hay solape y no hay nada que corregir.
 *
 * QUE BARRA SE OBSERVA
 * Desde el Bloque 4 la barra es la nuestra, `[data-lm-sticky-bar]`. La
 * consulta nombra tambien la nativa de Horizon, `.sticky-add-to-cart__bar`,
 * que hoy esta apagada en las dos plantillas pero se puede volver a encender
 * desde el editor: si eso pasa, el boton sigue apartandose en vez de quedar
 * encima. Las dos publican su estado en `data-stuck` con los mismos valores,
 * asi que todo lo de abajo funciona igual con cualquiera de las dos y no hay
 * ninguna rama que dependa de cual es.
 *
 * Por eso la decision no se toma con un breakpoint sino midiendo: si los dos
 * rectangulos se cruzan en horizontal, el boton sube por encima de la barra;
 * si no, se queda donde estaba. Un breakpoint fijo se equivoca en cuanto
 * alguien cambia el ancho de la barra desde el editor.
 *
 * La altura se publica como `--lm-wa-lift` y el CSS la suma a su `bottom`,
 * que ya incluye el safe-area-inset del iPhone.
 *
 * En las paginas sin sticky bar (portada, politicas) no hay nada que
 * observar: el CSS cae en el valor por defecto de la variable y el boton se
 * queda en su sitio.
 */
(() => {
  'use strict';

  const GAP = 12;

  /** Observadores vivos, para poder soltarlos cuando el editor reemplaza la seccion. */
  let attached = null;

  const detach = () => {
    if (!attached) return;
    attached.mutation.disconnect();
    attached.resize.disconnect();
    window.removeEventListener('resize', attached.update);
    attached = null;
  };

  const init = () => {
    const button = document.querySelector('[data-lm-whatsapp]');
    if (!button) return detach();

    const bar = document.querySelector('[data-lm-sticky-bar], .sticky-add-to-cart__bar');

    // Ya enganchado a esta misma barra: nada que rehacer.
    if (attached && attached.bar === bar) return;
    detach();

    if (!bar) {
      button.style.setProperty('--lm-wa-lift', '0px');
      return;
    }

    const update = () => {
      // `data-stuck` es lo que la barra alterna cuando entra y sale.
      const barRect = bar.getBoundingClientRect();

      if (bar.dataset.stuck !== 'true' || barRect.height === 0) {
        button.style.setProperty('--lm-wa-lift', '0px');
        return;
      }

      /*
       * El rect del boton se mide con el lift ya aplicado, asi que se compara
       * solo en horizontal: la vertical la resuelve el propio lift y medirla
       * aqui crearia un bucle (subo, ya no solapo, bajo, vuelvo a solapar).
       */
      const buttonRect = button.getBoundingClientRect();
      const overlaps = barRect.right > buttonRect.left && barRect.left < buttonRect.right;

      button.style.setProperty('--lm-wa-lift', overlaps ? `${Math.round(barRect.height) + GAP}px` : '0px');
    };

    const mutation = new MutationObserver(update);
    mutation.observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });

    const resize = new ResizeObserver(update);
    resize.observe(bar);

    window.addEventListener('resize', update, { passive: true });

    attached = { bar, update, mutation, resize };
    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Horizon reemplaza secciones enteras al editar en el theme editor.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
